import React from 'react';
import {
    Box,
    Text,
    Flex,
    IconButton,
    Tooltip,
} from "@chakra-ui/react";
import { DeleteIcon, CheckIcon } from "@chakra-ui/icons";
import { fileSize } from '../../utils/helper';

export const PdfCard = ({ pdf, onDelete, isHideDelete = false, isSelection = false, selectMedia, mediaUrl, showTooltip=false }) => {
    const size = fileSize(pdf)
    const url = !Array.isArray(mediaUrl) ? [mediaUrl] : mediaUrl
    return (
        <Tooltip label={pdf.name} visibility={showTooltip ? "visible" : "hidden"}>
            <Box
                key={pdf.id}
                bg="white"
                boxShadow="md"
                borderRadius="lg"
                overflow="hidden"
                position="relative"
                _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
                backgroundColor={url.includes(pdf.url) ? "blue.200" : "white"}
                onClick={isSelection ? () => selectMedia("pdf", pdf, pdf) : () => window.open(pdf.url, "_blank")}
            >
                <Box p={5}>
                    <Text fontWeight="bold" isTruncated>
                        {pdf.name}
                    </Text>
                    <Flex justify="space-between" align="center">
                        <Text fontSize="sm" color="gray.500">
                            {size}
                        </Text>
                        {
                            !isHideDelete ?
                                <IconButton
                                    aria-label="Delete"
                                    icon={<DeleteIcon />}
                                    size="sm"
                                    variant="ghost"
                                    colorScheme="red"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDelete(pdf.id)
                                    }}
                                /> :
                                <>
                                    {
                                        url.includes(pdf.url) ?
                                            <CheckIcon color="blue.500" /> : <></>
                                    }
                                </>
                        }
                    </Flex>
                </Box>
            </Box>
        </Tooltip>
    );
}
